{
  "tabs": {
    "overview": "Aperçu",
    "subaccount": "Sous-comptes",
    "affiliates": "Affiliés",
    "transfers": "Virements",
    "ledger": "Grand livre",
    "documents": "Documents",
    "portfolio": "Portefeuille",
    "trades": "Opérations"
  },
  "highlights": {
    "goalType": "Type de but : {{goalType}}",
    "timeHorizon": "Horizon temporel : {{timeHorizon}}",
    "targetAmount": "Cible : {{amount}}",
    "riskPreference": "Préférence pour le risque : {{level}}",
    "riskLevel": {
      "LEVEL_1": "Niveau 1",
      "LEVEL_2": "Niveau 2",
      "LEVEL_3": "Niveau 3",
      "LEVEL_4": "Niveau 4",
      "LEVEL_5": "Niveau 5"
    },
    "suitabilityScore": "Score d'adéquation : {{score}}",
    "goalPortfolio": "Portefeuille des objectifs",
    "tradingProcess": "Processus de négociation"
  },
  "timeHorizonDescription": {
    "VERY_SHORT_TERM": "Moins d'un an",
    "SHORT_TERM": "Dans 1 à 3 ans",
    "MID_TERM": "Dans 4 à 6 ans",
    "LONG_TERM": "7 ans et plus"
  },
  "linkedSubAccount_one": "1 sous-compte lié",
  "linkedSubAccount_other": "{{count}} sous-comptes liés",
  "percentageOfTotalAssets": "{{percentage}} de la valeur totale",
  "riskReturnLevel": "Risque et niveau de rendement de {{count}}",
  "autoTransferNotSet": "Le transfert automatique n'est pas activé",
  "autoTransferEnabled_one": "Virement automatique activé sur 1 portefeuille",
  "autoTransferEnabled_other": "Virement automatique activé sur {{count}} portefeuilles",
  "editGoal": "Modifier l'objectif",
  "dissociateGoalFromHousehold": "Dissocier du ménage",
  "edit": {
    "title": "Informations sur l'objectif",
    "goalType": "Type d'objectif",
    "targetAmount": "Montant cible",
    "timeHorizon": "Horizon temporel",
    "riskPreference": "Préférence pour le risque"
  },
  "holdings": "Actifs",
  "renameGoal": "Renommer l'objectif",
  "closeGoal": "Fermer l'objectif",
  "restoreGoal": "Restaurer l'objectif",
  "activeGoal": "Objectif actif",
  "closedGoal": "Objectif rapproché",
  "closeGoalDialog": {
    "title": "Êtes-vous sûr?",
    "subtitle": "Êtes-vous sûr de vouloir fermer cet objectif?",
    "continueButton": "Oui - je suis sûr",
    "cancelButton": "Annuler"
  },
  "toastMessage": {
    "error": "Quelque chose s'est mal passé",
    "success": "L'objectif a été correctement fermé",
    "restoreSuccess": "Vous avez réactivé cet objectif"
  },
  "closeGoalConfirmationDialog": {
    "title": "Impossible de fermer l'objectif",
    "subtitle": "Vous devez fermer tous les sous-comptes et annuler tous les dépôts programmés avant de procéder",
    "continueButton": "D'accord, j'ai compris"
  },
  "household": "Ménage",
  "changeToHouseholdGoal": "Passer à l'objectif du ménage {{name}}",
  "associateToHouseholdDialog": {
    "title": "Associer cet objectif au ménage {{name}}?",
    "checkingSubaccounts": "Vérification des sous-comptes de l'objectif",
    "thereAreSubAccounts": "Tous les comptes et sous-comptes liés seront également transférés au ménage. Cela comprend :",
    "thereAreNoSubAccounts": "Voulez-vous vraiment transférer ce compte au ménage?",
    "linkGoalToHousehold": "Cet objectif n'est actuellement associé à aucun sous-compte. Veuillez d'abord l'associer à un sous-compte. Une fois cette opération effectuée, vous pourrez ajouter l'objectif au ménage.",
    "continueButton": "Oui - je suis sûr",
    "gotItButton": "D'accord, j'ai compris",
    "cancelButton": "Annuler",
    "success": "Le compte a été associé au ménage.",
    "createSubAccount": "Créer un sous-compte"
  },
  "dissociateGoalDialog": {
    "checkingSubaccounts": "Vérification des sous-comptes de l'objectif",
    "title": "Dissocier ce compte du ménage {{name}}?",
    "continueButton": "Oui - je suis sûr",
    "cancelButton": "Annuler",
    "thereAreSubAccounts": "Tous les comptes et sous-comptes rattachés seront également supprimés du ménage. Il s'agit des comptes suivants:",
    "thereAreNoSubAccounts": "Voulez-vous vraiment supprimer ce compte du ménage?",
    "success": "L'objectif a été dissocié du ménage."
  }
}
